<template>
  <div>
    <list-widget :items="tenants.items" addNewRouteName="add-tenant" :addNewTitle="$t('top_bar.add_new_tenant')" routeName="tenant" :hideHeader="true"
                 :changeRoute="true"></list-widget>
    <div class="list-widget__footer items-container__footer" v-if="tenants.items">
      <slot name="footer"><a class="link" v-on:click.stop.prevent="extendLimit()"
                             v-if="tenants.items && tenants.total > tenants.items.length">{{ $t('common.load_more') }}</a></slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';

export default {
  components: {
    ListWidget,
  },
  computed: mapGetters({
    tenantsLimit: 'landlord/tenants/limit',
    tenants: 'landlord/tenants/tenants',
    tenant: 'tenants/tenant/updated',
    user: 'user/user/user',
  }),
  watch: {
    tenantsLimit() {
      this.fetchTenants();
    },
    '$route.params.id': function () {
      this.fetchTenants(); // Fetch tenants when the route parameter "id" changes
    },
  },
  created() {
    this.fetchTenants(); // Fetch tenants when the component is created
    this.$store.commit(`landlord/tenants/${mTypes.SET_LIMIT}`, 10);
  },
  methods: {
    fetchTenants() {
      const id = this.$route.params.id;
      const keyword = this.$route.query.keyword;
      this.$store.dispatch('landlord/tenants/fetch', {keyword, id, user: this.user});
    },
    extendLimit() {
      this.$store.commit(`landlord/tenants/${mTypes.SET_LIMIT}`, this.tenantsLimit + 10);
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/tenants/Sidebar.vue